import { users, UserDomainObject } from "utils/constants"
import { RouteProps } from "models"

interface RoutesIndex {
	[key: string]: RouteProps
}

const anyUser: Array<string> = users.map(({ role }: UserDomainObject) => role)

export const publicRoutes: RoutesIndex = {
	signin: {
		path: "/se-connecter",
	},
	signup: {
		path: "/s-inscrire",
	},
	lostPassword: {
		path: "/mot-de-passe-perdu",
	},
	notFound: {
		path: "/page-introuvable",
	},
	contact: {
		path: "/contact",
	},
	faq: {
		path: "/faq",
	},
	propertyTransferRequest: {
		path: "/modifier-mon-velo",
	},
	portabilityRequest: {
		path: "/changer-d-operateur",
	},
	decathlon: {
		path: "/decathlon",
	},
	bicycode: {
		path: "/bicycode",
	},
	moustache: {
		path: "/moustache",
	},
}

export const privateRoutes = {
	dashboard: {
		path: "/mes-velos",
		authorizedUserRoles: [...anyUser],
	},
	registerBike: {
		path: "/ajouter-un-velo",
		authorizedUserRoles: [...anyUser],
	},
	bike: {
		path: "/velo/:slug",
		basePath: "/velo",
		userRoles: [...anyUser],
	},
	account: {
		path: "/mon-profil",
		userRoles: [...anyUser],
	},
	notAuthorized: {
		path: "/non-autorise",
		authorizedUserRoles: [...anyUser],
	},
}
